var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle2195(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 46,
    viewBox: "0 0 321 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C126.876 11.9608 198.025 18.7815 321 0V46C189.511 19.7437 119.249 19.5437 0 46V0Z",
    fill: "url(#paint0_linear_413_13501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_413_13501",
    x1: -57.1644,
    y1: -1.8012,
    x2: 202.732,
    y2: 230.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105188,
    stopColor: "#F875DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401176,
    stopColor: "#F1DD5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594967,
    stopColor: "#F77A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746947,
    stopColor: "#F26BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921186,
    stopColor: "#65A7F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle2195);
export default __webpack_public_path__ + "static/media/Rectangle_2195.0c33a4928580e18f00785ac9f787dc1d.svg";
export { ForwardRef as ReactComponent };